import { useModal } from '@/composables/useModal'

const personalisationModal = useModal()

export const usePersonalisationModal = () => personalisationModal
